import { render } from "./CulturalEventsSection.vue?vue&type=template&id=09e0dbbc&scoped=true"
import script from "./CulturalEventsSection.vue?vue&type=script&lang=js"
export * from "./CulturalEventsSection.vue?vue&type=script&lang=js"

import "./CulturalEventsSection.vue?vue&type=style&index=0&id=09e0dbbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e0dbbc"]])

export default __exports__